(function () {
  const bindProductLabels = (section) => {
    if (!section.classList.contains('hero-banner-v1--labels-on-hover')) return;

    section.querySelectorAll('.hero-banner-v1__product').forEach((product) => {
      if (product.dataset.labelBound === 'true') return;

      const label = product.querySelector('.hero-banner-v1__product-label');
      const imageWrapper = product.querySelector('.hero-banner-v1__product-image-wrapper');
      if (!label || !imageWrapper) return;

      product.dataset.labelBound = 'true';

      // Make non-link wrappers keyboard-focusable for focus-within labels
      if (imageWrapper.tagName !== 'A' && !imageWrapper.hasAttribute('tabindex')) {
        imageWrapper.setAttribute('tabindex', '0');
        imageWrapper.setAttribute('role', 'img');
        const img = imageWrapper.querySelector('.hero-banner-v1__product-image');
        if (img && img.getAttribute('alt')) {
          imageWrapper.setAttribute('aria-label', img.getAttribute('alt'));
        }
      }

      const show = () => product.classList.add('is-label-visible');
      const hide = () => product.classList.remove('is-label-visible');

      product.addEventListener('mouseenter', show);
      product.addEventListener('mouseleave', hide);
      product.addEventListener('focusin', show);
      product.addEventListener('focusout', (event) => {
        if (!product.contains(event.relatedTarget)) hide();
      });
    });
  };

  const initHeroBannerV1Carousel = (root) => {
    const sections = (root || document).querySelectorAll('.hero-banner-v1[data-carousel-enabled="true"]');

    sections.forEach((section) => {
      if (section.dataset.carouselBound === 'true') return;

      const track = section.querySelector('.hero-banner-v1__products-track');
      if (!track) return;

      section.dataset.carouselBound = 'true';

      const slideDelay = parseInt(section.dataset.slideDelay, 10) || 2000;
      const slideDuration = parseInt(section.dataset.slideDuration, 10) || 600;
      const minProducts = parseInt(section.dataset.minProducts, 10) || 5;

      let isAnimating = false;

      const getProducts = () => Array.from(track.querySelectorAll('.hero-banner-v1__product'));

      const getStepWidth = () => {
        const products = getProducts();
        if (products.length < 2) return 0;
        return products[1].offsetLeft - products[0].offsetLeft;
      };

      const moveOneCard = () => {
        const products = getProducts();

        if (isAnimating || products.length < minProducts) return;

        const stepWidth = getStepWidth();
        if (!stepWidth) return;

        isAnimating = true;
        products[0].classList.remove('is-label-visible');

        track.style.transition = `transform ${slideDuration}ms ease`;
        track.style.transform = `translateX(-${stepWidth}px)`;

        window.setTimeout(() => {
          track.style.transition = 'none';
          track.style.transform = 'translateX(0)';
          track.appendChild(products[0]);
          track.offsetHeight;
          track.style.transition = `transform ${slideDuration}ms ease`;
          isAnimating = false;
        }, slideDuration);
      };

      if (section._heroBannerV1Interval) {
        window.clearInterval(section._heroBannerV1Interval);
      }

      section._heroBannerV1Interval = window.setInterval(moveOneCard, slideDelay);
    });
  };

  const initHeroBannerV1 = (root) => {
    const scope = root || document;
    scope.querySelectorAll('.hero-banner-v1').forEach((section) => {
      bindProductLabels(section);
    });
    initHeroBannerV1Carousel(scope);
  };

  const onReady = () => initHeroBannerV1(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.hero-banner-v1') || event.target.closest('.hero-banner-v1');
    if (section) {
      section.dataset.carouselBound = 'false';
      section.querySelectorAll('.hero-banner-v1__product').forEach((product) => {
        delete product.dataset.labelBound;
      });
      initHeroBannerV1(event.target);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('.hero-banner-v1') || event.target.closest('.hero-banner-v1');
    if (section && section._heroBannerV1Interval) {
      window.clearInterval(section._heroBannerV1Interval);
    }
  });
})();
